import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { OpenRedPocketEnvelopeRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { OpenRedPocketEnvelopeResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const openRedPocketEnvelope = (request: OpenRedPocketEnvelopeRequest, options?: CashRequestOptions) =>
  post<OpenRedPocketEnvelopeRequest, OpenRedPocketEnvelopeResponse>('/2.0/cash/open-red-pocket-envelope', request, {
    ...options,
    rejectOnError: true,
  })
